import http from '@/libs/http'
export default (params) => {
  return http.get(`${process.env.VUE_APP_MICROSERVICE_API_FACTURACION}/find-ordenes-venta`, { params, headers: { loading: true } })
}
